import { Vue, Component , Prop, Watch } from 'vue-property-decorator';
import { LoginModel, LoginTokenModel } from './login.model';
import { loginService } from './Login.services';






@Component
export default class Login extends Vue{
    public loginModel!: LoginModel;
    public fullPage: boolean = true;
    public loginToken!: LoginTokenModel;
    public submitted :boolean = false;
    public errorMessage: string = '';
    public buttonDisabled: boolean = false;
    public $loading: any
    public data(){
        return{
            loginModel : new LoginModel(),
            loginToken: new LoginTokenModel(),
            submitted: false,
            errorMessage: '',
            buttonDisabled: false
        };
    }
    constructor(){
        super();
    }
    
    mounted(): void{
        console.log(this.loginModel);
    }

    clearSEMessage(){
        console.log("clear SE Message");
        console.log(this.errorMessage);
        this.errorMessage = '';
    }

    addLoginToken(loginToken: any) {
        this.$store.dispatch("addLoginToken", loginToken);
      }

    changeLoggedInStatus(){
        this.$store.dispatch("changeLoggedInStatus");
      }
      
    login(){
   

        this.buttonDisabled = true;
        this.submitted = true;
        if( this.loginModel.password.trim().length <1)
        {    
                
          this.$validator.validate('password');
    
        }
   
        this.$validator.validate().then(valid => {
            console.log('valid flag - ',valid);
            if (valid) {
               this.getToken();            
            }else{
                console.log('error has happended');
                // this.$validator.validate('password').then(valid => {console.log("valid")});
                this.buttonDisabled = false;
            }
        });  
    }

    public async getToken(): Promise<void>{
        let loginCredentials = JSON.stringify(this.loginModel);
        let parsedData = JSON.parse(loginCredentials);
        let data = {
            data: parsedData
        }
        let loader = this.$loading.show({
            // Optional parameters
            container: this.fullPage ? null : this.$refs.formContainer,
            canCancel: false,
            // onCancel: this.onCancel,
          });
        const res = loginService.getToken(data).then((response:any) => {
            this.loginToken = <LoginTokenModel>response.data['data'];
            this.addLoginToken(this.loginToken);
            loader.hide();
            this.buttonDisabled = false;
            this.$router.push('/email-template');
        }).catch((error) => {
            console.log(error);
            this.buttonDisabled = false;
            loader.hide();
            console.log(error.response);
            this.errorMessage = error.response.data['data']['message'];
        })
    }
}